import CalendlyScheduleDialog from './CalendlyScheduleDialog';
import FadeIn from '@/components/shared/FadeIn';

const MidPageCTASection: React.FC = () => {
  return (
    <section id="get-started" className="relative overflow-hidden min-h-[75vh] flex items-center">
      {/* Full-bleed background */}
      <img
        src="/static/images/parq-1600.jpg"
        alt="Construction site"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />

      {/* Strong gradient — text readable from any image */}
      <div className="absolute inset-0 bg-gradient-to-r from-maintenance-dark/95 via-maintenance-dark/75 to-maintenance-dark/30" />
      <div className="absolute inset-0 bg-gradient-to-t from-maintenance-dark/60 via-transparent to-transparent" />

      <div className="relative z-10 container mx-auto px-6 md:px-12 lg:px-16 py-24">
        <div className="max-w-2xl">
          <FadeIn>
            <p className="text-maintenance-cyan text-xs uppercase tracking-widest font-semibold mb-5">
              Getting Started
            </p>

            <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.02] mb-6">
              See it for yourself.
            </h2>
          </FadeIn>

          <FadeIn delay={150}>
            <p className="text-white/60 text-lg md:text-xl leading-relaxed mb-4 max-w-xl">
              Schedule a Lunch &amp; Learn and we'll show your team exactly how Ironview 360 eliminates disputes, reduces travel, and creates the permanent documentation record your projects deserve.
            </p>
            <p className="text-white/40 text-sm mb-10">
              Since 2017 &nbsp;·&nbsp; 10M+ sq ft documented &nbsp;·&nbsp; No commitment required
            </p>
          </FadeIn>

          <FadeIn delay={280}>
            <div className="flex flex-col sm:flex-row gap-4 items-start">
              <CalendlyScheduleDialog
                triggerText="Schedule a Lunch & Learn"
                fullWidthMobile={false}
                className="px-8 py-3 text-base"
              />
              <a
                href="mailto:timur@ironview360.com"
                className="text-white/50 hover:text-white text-sm self-center underline underline-offset-4 transition-colors"
              >
                Or reach out directly →
              </a>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
};

export default MidPageCTASection;
